import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import it from './locales/it.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import zh from './locales/zh.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      English: { translation: en },
      Italian: { translation: it },
      Spanish: { translation: es },
      French: { translation: fr },
      German: { translation: de },
      Chinese: { translation: zh },
    },
    lng: localStorage.getItem('language') || 'English',
    fallbackLng: 'English',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
